import { PageInfoDto } from '@/dto';
import { FIELDS } from './constants';

export let dataItem = [
      FIELDS.ID,
    FIELDS.NAME,
    FIELDS.ACTIVE,

];

export let dataInfo = [
      FIELDS.ID,
    FIELDS.NAME,
    FIELDS.CREATED_BY_USER_ID,
    FIELDS.MODIFIED_BY_USER_ID,
    FIELDS.DATE_CREATED,
    FIELDS.DATE_MODIFIED,
    FIELDS.ACTIVE,

];

export class listDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class dataItemDto {
  constructor(data = {}) {
    dataItem.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    dataInfo.forEach(key => (this[key] = data[key] || null));
  }
}
